import { useState, useId } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { FormGroup, Input, Checkbox } from '@theneatcompany/nui'

import { getMessage } from '@/utils/messages'

import FieldError from './FieldError'
import styles from './PasswordField.module.scss'

const PasswordField = ({
  labelProps = {},
  label = labelProps.label,
  errorProps = {},
  name,
  ...inputProps
}) => {
  const [field, { error, touched }] = useField(name)
  const id = useId()
  const placeholder = inputProps.placeholder || getMessage('placeholders.password')
  const [isPasswordShown, setIsPasswordShown] = useState(false)

  const hasErrors = !!(error && touched)

  return (
    <FormGroup intent={hasErrors ? 'danger' : 'default'}>
      <FormGroup.Label htmlFor={id} label={label} {...labelProps} />
      <div className={styles.field}>
        <Input
          {...inputProps}
          id={id}
          placeholder={placeholder}
          type={isPasswordShown ? 'text' : 'password'}
          {...field}
        />
        <span className={cx(styles.checkbox, hasErrors && styles.hasErrors)}>
          <Checkbox
            id={`${id}-checkbox`}
            checked={isPasswordShown}
            name="show"
            label={getMessage('labels.show')}
            onChange={() => setIsPasswordShown(!isPasswordShown)}
          />
        </span>
      </div>
      <FieldError message={error} label={label} touched={touched} {...errorProps} />
    </FormGroup>
  )
}

PasswordField.propTypes = {
  label: PropTypes.node,
  labelProps: PropTypes.shape({
    label: PropTypes.node,
  }),
  errorProps: PropTypes.shape({
    onRender: PropTypes.func,
  }),
  name: PropTypes.string.isRequired,
}

export default PasswordField
